var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTakeout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 84,
    viewBox: "0 0 72 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1437 49.6204C36.2898 48.7011 34.1724 50.6124 33.3455 51.6829C31.4859 53.3682 36.1195 56.3897 38.3455 56.8273C40.5715 57.2648 43.3992 55.4553 45.3513 53.7581C47.3033 52.061 51.2384 53.9668 50.8795 53.0485C50.8795 53.0485 52.0286 50.7312 48.9997 49.6734C45.9707 48.6157 39.9976 50.5397 38.1437 49.6204Z",
    fill: "#C3A37A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 33.2826L9.6087 68.4348L10.3261 29.6957L4.58696 23.2391L1 33.2826Z",
    fill: "#A27857",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30432 23.2391L24.6739 1H36.1521L54.8043 16.0652V23.2391H63.413L71.3043 55.5217L63.413 68.4348L47.6304 53.3696H32.5652L10.3261 68.4348V46.1957V29.6957L5.30432 23.2391Z",
    fill: "#A27857"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3261 46.1957H50.5L63.413 68.4348M10.3261 46.1957V29.6957L5.30432 23.2391M10.3261 46.1957V68.4348L32.5652 53.3696H47.6304L63.413 68.4348M63.413 68.4348L54.8043 23.2391M63.413 68.4348L71.3043 55.5217L63.413 23.2391H54.8043M54.8043 23.2391H5.30432M54.8043 23.2391V16.0652L36.1521 1H24.6739L5.30432 23.2391",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2073 34.4341C41.6203 38.0209 40.4725 37.8776 33.0116 45.9124C25.5508 53.9471 33.0116 51.6515 33.0116 51.6515C33.0116 51.6515 44.4899 42.3255 47.3594 38.0211C48.2656 36.6618 48.7943 30.8473 45.2073 34.4341Z",
    fill: "#93A752",
    stroke: "black",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8043 23.2391L50.5 46.1957",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9744 46.2629C35.9768 45.723 34.273 48.0107 33.6709 49.222C32.1759 51.2377 37.31 53.2971 39.5786 53.2919C41.8472 53.2867 44.2674 50.9602 45.8508 48.9148C47.4342 46.8693 51.6655 47.9707 51.1343 47.1401C51.1343 47.1401 51.8092 44.6431 48.6321 44.1967C45.4549 43.7503 39.972 46.8028 37.9744 46.2629Z",
    fill: "#C3A37A",
    stroke: "black",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0847 45.2599C29.0454 45.8406 28.2352 45.0149 17.3967 46.6726C6.55813 48.3303 13.8298 51.1688 13.8298 51.1688C13.8298 51.1688 28.6182 50.9963 33.5414 49.4075C35.0961 48.9059 39.124 44.6792 34.0847 45.2599Z",
    fill: "#93A752",
    stroke: "black",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.999 52.8113C53.5596 50.3571 53.3797 49.2145 43.5939 44.2686C33.8081 39.3228 38.0789 45.8569 38.0789 45.8569C38.0789 45.8569 50.2173 54.3059 55.1477 55.8721C56.7047 56.3667 62.4384 55.2656 57.999 52.8113Z",
    fill: "#93A752",
    stroke: "black",
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5148 49.0516C51.707 45.7001 51.777 44.5455 43.2838 37.611C34.7905 30.6765 37.5563 37.9762 37.5563 37.9762C37.5563 37.9762 47.5937 48.8378 52.072 51.4277C53.4862 52.2455 59.3226 52.4031 55.5148 49.0516Z",
    fill: "#DB8A60",
    stroke: "black",
    strokeWidth: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.33 54.9631C52.3059 54.2626 51.7285 53.2603 40.8204 52.1494C29.9122 51.0384 36.2407 55.6083 36.2407 55.6083C36.2407 55.6083 50.6006 59.1468 55.7648 58.8423C57.3956 58.7462 62.354 55.6636 57.33 54.9631Z",
    fill: "#DB8A60",
    stroke: "black",
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7456 46.8825C30.3761 49.4592 29.3006 49.0335 20.0686 54.9491C10.8366 60.8646 18.6345 60.5061 18.6345 60.5061C18.6345 60.5061 32.079 54.3442 35.9332 50.8934C37.1502 49.8037 39.1151 44.3058 34.7456 46.8825Z",
    fill: "#DB8A60",
    stroke: "black",
    strokeWidth: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.087 39.0217C19.3653 37.8739 17.0218 39.5 16.0653 40.4565C14.0063 41.8913 18.2175 45.4783 20.3696 46.1956C22.5218 46.913 25.3912 49.0652 27.5435 47.6304C29.6957 46.1956 33.5218 45 33.2827 44.0435C33.2827 44.0435 34.7175 41.8913 31.8479 40.4565C28.9782 39.0217 22.8088 40.1696 21.087 39.0217Z",
    fill: "#C4A37A",
    stroke: "black",
    strokeWidth: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.689 50.7528C13.6914 50.2129 11.9876 52.5006 11.3855 53.7119C9.89046 55.7276 15.0246 57.787 17.2932 57.7817C19.5618 57.7765 21.982 55.45 23.5654 53.4046C25.1488 51.3592 29.3801 52.4606 28.8489 51.63C28.8489 51.63 29.5238 49.1329 26.3467 48.6866C23.1695 48.2402 17.6866 51.2927 15.689 50.7528Z",
    fill: "#C3A37A",
    stroke: "black",
    strokeWidth: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8793 59.0896C16.3987 57.644 13.7955 58.8101 12.6791 59.5739C10.3908 60.6045 13.8685 64.9063 15.8515 66.0082C17.8345 67.1101 21.0821 66.2595 23.462 65.2461C25.8419 64.2328 28.9987 67.2579 28.94 66.2737C28.94 66.2737 30.747 64.423 28.1911 62.4837C25.6352 60.5445 19.3599 60.5352 17.8793 59.0896Z",
    fill: "#C3A37A",
    stroke: "black",
    strokeWidth: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.579 54.9784C15.2716 55.7406 18.8613 56.6306 19.6796 54.0922",
    stroke: "#8F7759",
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.087 43.326C22.0435 44.7608 24.387 47.2 26.1087 45.4782",
    stroke: "#8F7759",
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1957 83.4999L9.6087 68.4347L32.5652 53.3695H47.6304L64.1304 68.4347L56.9565 83.4999H13.1957Z",
    fill: "#A27857"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6087 68.4347L13.1957 83.4999H56.9565L64.1304 68.4347M9.6087 68.4347H64.1304M9.6087 68.4347L32.5652 53.3695H47.6304L64.1304 68.4347",
    stroke: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeout);
export default __webpack_public_path__ + "static/media/takeout.7819dd9ffa707ce55bf67b7faa0c7fea.svg";
export { ForwardRef as ReactComponent };